import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Message } from 'primeng/api/message';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { CardModule } from 'primeng/card';
import { InputTextModule } from 'primeng/inputtext';
import { MessagesModule } from 'primeng/messages';

@Component({
  selector: 'app-new-verification',
  standalone: true,
  imports: [CommonModule,InputTextModule,CardModule,ButtonModule,MessagesModule, CalendarModule, InputTextModule],
  templateUrl: './new-verification.component.html',
  styleUrl: './new-verification.component.scss',
  providers: [MessagesModule]
})
export class NewVerificationComponent {

  verificationForm!: FormGroup;
  messages!: Message[];

  constructor(private fb: FormBuilder){}

  ngOnInit(){

  }

  initializeForm(){
    this.verificationForm = this.fb.group({
      paymentReference: ['', [Validators.required]]
    })
  }

}
